import React from 'react';
import { Paper, Typography, SxProps, Theme } from '@mui/material';

// Define props type for WSIconCard component
interface WSIconCardProps {
  icon: React.ReactElement; // Accept a React element as an icon
  name?: string;             // The name to display in the card
  sx?: SxProps<Theme>;      // Additional styles as sx prop from Material UI
  onClick?: () => void;        // Optional onClick event handler
}

const WSIconCard: React.FC<WSIconCardProps> = ({ icon, name, sx,onClick  }) => {
  return (
    <Paper
    onClick={onClick}    
      sx={{
        border: '1px solid lightgrey', 
        borderRadius: '4px', 
        padding: '16px', 
        display: 'flex', 
        flexDirection: 'column', 
        alignItems: 'center', 
        width: '9rem', 
        textAlign: 'center',
        height: '7rem',
        ...sx, // Merge any custom styles passed via props
        cursor:'pointer'
      }}
    >
      {/* Render the icon element passed via props */}
      {icon}

      {/* Render the name */}
      <Typography variant="body2" sx={{ fontSize: '1rem', marginTop: '1rem' }}>{name}</Typography>
    </Paper>
  );
};

export default WSIconCard;
